<template>
  <div class="pa-2 rounded elevation-1 bg-white" id="shopping_cart">
    <div class="text-h6 mb-2">Ma commande</div>
    <div v-if="mainStore.inscription_as_admin" class="mb-3">
      <v-alert>En inscription administrateur, le panier est donné à titre indicatif. </v-alert>
    </div>
    <div class="d-flex justify-content-between align-center mb-2">
      <v-badge :content="bookingStore.nb_articles">
        <v-icon icon="mdi-cart" color="primary" size="x-large"></v-icon>
      </v-badge>
      <div class="d-flex flex-column align-end" v-if="!mainStore.inscription_as_admin">
        <div>Sous total: {{ bookingStore.prix }}€</div>
        <div v-if="!bookingStore.exclude_taxe">Frais de gestion: {{ bookingStore.taxe }}€</div>
        <div class="text-h6">
          A payer: <span class="font-weight-bold">{{ bookingStore.prix_total }}€</span>
        </div>
      </div>
      <div class="d-flex flex-column align-end" v-else>
        <div>
          Total: <span class="font-weight-bold">{{ bookingStore.prix }}€</span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap">
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(inscription, index_inscription) in bookingStore.inscriptions"
        :key="index_inscription">
        <div class="text-body font-weight-bold">{{ get_nom_coureur(inscription.coureur, index_inscription) }} {{
          inscription.get_equipe_name() != '' ? ' - Equipe ' + inscription.get_equipe_name() : '' }}</div>
        <CartCoureurItem :item="inscription"></CartCoureurItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import CartCoureurItem from "@/components/App/Shopping_Cart/Cart_Coureur_Item.vue";
export default {
  components: { CartCoureurItem },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
    get_nom_coureur(coureur, index) {
      let nom = coureur.get_nom();
      if (nom.length > 1) {
        return nom;
      }

      if (!this.mainStore.is_default_mode) {
        return "Participant n°" + parseInt(index + 1);
      } else {
        return "Coureur n°" + parseInt(index + 1);
      }
    },
  },
  created() {
    this.bookingStore.compute_cart(this.mainStore.inscription_vip);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/Cart.scss";
</style>